(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("axis-grid", [], factory);
	else if(typeof exports === 'object')
		exports["axis-grid"] = factory();
	else
		root["axis-grid"] = factory();
})(self, function() {
return 